import React, { Component } from 'react'
import { infoMsg, siteContent } from '@services/api'
import { Icon, Row, Switch, Select, Button } from 'antd'

export default class extends Component {
    state = {
        types: [],
        type: '',
        values: {},
        newKey: '',
        allContent: {}
    }

    init = async () => {
        let types,
            allContent = {},
            values = {}

        await infoMsg
            .getTypes()
            .then(res => {
                types = Object.keys(res.data)
            })
            .catch(err => console.log(err))

        await siteContent.getSiteLngs().then(res => {
            res.data.map(slot => {
                values[slot.lng] = ''
            })
        })

        await infoMsg
            .getApiContent()
            .then(res => res.data.map(it => (allContent[it.type] = { ...JSON.parse(it.keys) })))

        this.setState({ types, values, allContent, newKey: '' })
    }

    componentDidMount() {
        this.init()
    }

    render() {
        const { types, type, values, newKey, allContent } = this.state

        return !types.length ? (
            <Icon type="loading" />
        ) : (
            <>
                <Row gutter={28} style={{ marginBottom: '1rem' }}>
                    <span style={{ marginLeft: '0.7rem' }}>
                        מפתח:
                        <input value={newKey} onChange={e => this.setState({ newKey: e.target.value })} />
                    </span>
                    <span>
                        type:
                        <Select
                            id="set_type"
                            value={type}
                            style={{ width: '20%' }}
                            placeholder="בחר type"
                            onChange={type => this.setState({ type })}
                        >
                            {types.map((slot, idx) => (
                                <Select.Option value={slot} key={idx}>
                                    {slot}
                                </Select.Option>
                            ))}
                        </Select>
                    </span>
                </Row>

                {Object.entries(values).map(([key, value], idx) => (
                    <Row key={idx} gutter={28}>
                        <span>
                            {key} -
                            <input
                                value={value}
                                onChange={e =>
                                    this.setState({
                                        values: {
                                            ...values,
                                            [key]: e.target.value
                                        }
                                    })
                                }
                            />
                        </span>
                    </Row>
                ))}
                <Button
                    style={{ marginTop: 10 }}
                    onClick={() => {
                        infoMsg.addContent({ type, values, newKey }).then(() => {
                            this.init()
                        })
                    }}
                    disabled={
                        !type ||
                        !newKey ||
                        !!Object.values(values).filter(val => !val).length ||
                        (allContent[type] && !!allContent[type][newKey])
                    }
                >
                    <Icon type="check" />
                </Button>
            </>
        )
    }
}
